import React from 'react';
import { Code, Github, Twitter, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="mt-12 py-8 px-4 border-t border-[#d0d7de] bg-[#f6f8fa]" data-id="element-51">
      <div className="max-w-[1280px] mx-auto flex flex-col md:flex-row items-center justify-between gap-6 text-xs text-[#57606a]" data-id="element-52">
        <div className="flex items-center gap-2 order-2 md:order-1" data-id="element-53">
          <div className="p-1 rounded-full bg-gray-200 text-[#57606a]" data-id="element-54">
            <Code size={16} data-id="element-55" />
          </div>
          <span data-id="element-56">© 2024 Code Vanta Solutions, Inc.</span>
        </div>

        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 order-1 md:order-2" data-id="element-57">
          <a href="#" className="hover:text-[#0969da] hover:underline" data-id="element-58">
            Terms
          </a>
          <a href="#" className="hover:text-[#0969da] hover:underline" data-id="element-59">
            Privacy
          </a>
          <a href="#" className="hover:text-[#0969da] hover:underline" data-id="element-60">
            Security
          </a>
          <a href="#" className="hover:text-[#0969da] hover:underline" data-id="element-61">
            Status
          </a>
          <a href="#" className="hover:text-[#0969da] hover:underline" data-id="element-62">
            Docs
          </a>
          <a href="#" className="hover:text-[#0969da] hover:underline" data-id="element-63">
            Contact
          </a>
          <a href="#" className="hover:text-[#0969da] hover:underline" data-id="element-64">
            Pricing
          </a>
          <a href="#" className="hover:text-[#0969da] hover:underline" data-id="element-65">
            API
          </a>
        </div>

        <div className="flex items-center gap-4 order-3" data-id="element-66">
          <a href="#" className="text-[#57606a] hover:text-[#24292f]" data-id="element-67">
            <Github size={18} data-id="element-68" />
          </a>
          <a href="#" className="text-[#57606a] hover:text-[#24292f]" data-id="element-69">
            <Twitter size={18} data-id="element-70" />
          </a>
          <a href="#" className="text-[#57606a] hover:text-[#24292f]" data-id="element-71">
            <Linkedin size={18} data-id="element-72" />
          </a>
        </div>
      </div>

      <div className="text-center mt-6 text-[10px] text-[#57606a] opacity-60" data-id="element-73">
        Built with ❤️ and lots of ☕
      </div>
    </footer>;
}